import { Injectable } from '@angular/core';
import { environment } from '@env';
import { UserService } from './user.service';

@Injectable({ providedIn: 'root' })
export class RedirectService {
  constructor(private userService: UserService) {}

  public redirectToTrebek(): void {
    window.open(
      `${environment.trebekBaseUrl}user-check?triviaUser=${this.userService.accessToken}`,
      '_blank'
    );
  }
}
